import { AnnotationsButton as SharedAnnotationsButton } from '@backoffice-frontend/overwatch-map-common'
import type { SetStateAction } from 'react'
import { useSharedMapContext } from '../SharedMapContext'

/**
 * Route-builder's binding for the shared Annotations button.
 *
 * The button, its filters and the map layer all live in
 * `@backoffice-frontend/overwatch-map-common` so the trip-history map renders the
 * same feature from the same code. All this wrapper adds is the two things that
 * are specific to this area: reading the one {@link AnnotationsState} the map
 * layer also reads out of `SharedMapContext`, and translating the rail's shared
 * `openMapMenu` value into the plain boolean the button expects, so opening this
 * dropdown closes the Layers one and vice versa. Rendered through `MapControls`'
 * `extraButtons` slot in `RouteBuilderAreaContentView`.
 *
 * `showNearRouteFilter` is unconditional here because this map always has a route
 * being built for the proximity filter to measure against. Trip-history leaves it
 * (and the date filter) out: its map shows only the one trip's own notes.
 */
export const AnnotationsButton = () => {
  const { annotations, openMapMenu, setOpenMapMenu } = useSharedMapContext()

  const isOpen = openMapMenu === 'annotations'
  // useActionMenu may hand back an updater rather than a boolean, so resolve it
  // against the derived `isOpen` before mapping it onto the shared menu value.
  const setIsOpen = (value: SetStateAction<boolean>) => {
    const next = typeof value === 'function' ? value(isOpen) : value
    setOpenMapMenu(next ? 'annotations' : null)
  }

  return (
    <SharedAnnotationsButton
      state={annotations}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      showNearRouteFilter
    />
  )
}
